module.exports = __webpack_public_path__ + "static/media/4.ff25b9fb.jpg";